require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.array.from");

var _objectWithoutProperties = require("C:/Users/Gurpreet Singh/Documents/Gatsby/Appraisir/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _toArray = require("C:/Users/Gurpreet Singh/Documents/Gatsby/Appraisir/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/toArray");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.map");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es7.object.values");

require("core-js/modules/es6.array.filter");

var _defineProperty = require("C:/Users/Gurpreet Singh/Documents/Gatsby/Appraisir/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _toConsumableArray = require("C:/Users/Gurpreet Singh/Documents/Gatsby/Appraisir/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.string.trim");

var _classCallCheck = require("C:/Users/Gurpreet Singh/Documents/Gatsby/Appraisir/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("C:/Users/Gurpreet Singh/Documents/Gatsby/Appraisir/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e5) { throw _e5; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e6) { didErr = true; err = _e6; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports) : "function" == typeof define && define.amd ? define(["exports"], e) : e((t = "undefined" != typeof globalThis ? globalThis : t || self).DiceBear = {});
}(this, function (t) {
  "use strict";

  function e(t, e, r) {
    return e in t ? Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = r, t;
  }

  var r = -2147483648,
      n = 2147483647;

  function a(t) {
    return t ^= t << 13, t ^= t >> 17, t ^= t << 5;
  }

  function i(t) {
    var e;

    var i = function (t) {
      var e = 0;

      for (var _r = 0; _r < t.length; _r++) {
        e = (e << 5) - e + t.charCodeAt(_r) | 0, e = a(e);
      }

      return e;
    }(t = null !== (e = t) && void 0 !== e ? e : r + Math.floor((n - r) * Math.random()).toString()) || 1;

    var o = function o(t, e) {
      return Math.floor(((i = a(i)) - r) / (n - r) * (e + 1 - t) + t);
    };

    return {
      seed: t,
      bool: function bool() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 50;
        return o(0, 100) < t;
      },
      integer: function integer(t, e) {
        return o(t, e);
      },
      pick: function pick(t) {
        return t[o(0, t.length - 1)];
      }
    };
  }

  var o = Object.freeze({
    __proto__: null,
    create: i
  });

  var c = /*#__PURE__*/function () {
    function c(t) {
      _classCallCheck(this, c);

      e(this, "prng", void 0), e(this, "seed", void 0), this.prng = i(t), this.seed = this.prng.seed;
    }

    _createClass(c, [{
      key: "bool",
      value: function bool() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 50;
        return this.prng.bool(t);
      }
    }, {
      key: "integer",
      value: function integer(t, e) {
        return this.prng.integer(t, e);
      }
    }, {
      key: "pickone",
      value: function pickone(t) {
        return this.prng.pick(t);
      }
    }]);

    return c;
  }();

  var s = function s(t) {
    4 !== t.length && 5 !== t.length || (t = function (t) {
      for (var e = "#", r = 1; r < t.length; r++) {
        var n = t.charAt(r);
        e += n + n;
      }

      return e;
    }(t));
    var e = [parseInt(t.substring(1, 3), 16), parseInt(t.substring(3, 5), 16), parseInt(t.substring(5, 7), 16)];

    if (9 === t.length) {
      var r = parseFloat((parseInt(t.substring(7, 9), 16) / 255).toFixed(2));
      e.push(r);
    }

    return e;
  };

  var u = function u(t) {
    var e,
        r,
        n = t[0],
        a = t[1],
        i = t[2],
        o = Math.min(n, a, i),
        c = Math.max(n, a, i),
        s = c - o;
    return r = 0 == c ? 0 : s / c * 1e3 / 10, c == o ? e = 0 : n == c ? e = (a - i) / s : a == c ? e = 2 + (i - n) / s : i == c && (e = 4 + (n - a) / s), (e = Math.min(60 * e, 360)) < 0 && (e += 360), [e, r, c / 255 * 1e3 / 10];
  };

  var l = function l(t, e, r) {
    return Math.min(Math.max(t, e), r);
  };

  function f(t) {
    var e = Math.round(l(t, 0, 255)).toString(16);
    return 1 == e.length ? "0" + e : e;
  }

  var p = function p(t) {
    var e = 4 === t.length ? f(255 * t[3]) : "";
    return "#" + f(t[0]) + f(t[1]) + f(t[2]) + e;
  };

  var h = function h(t) {
    var e = t[0] / 60,
        r = t[1] / 100,
        n = t[2] / 100,
        a = Math.floor(e) % 6,
        i = e - Math.floor(e),
        o = 255 * n * (1 - r),
        c = 255 * n * (1 - r * i),
        s = 255 * n * (1 - r * (1 - i));

    switch (n *= 255, a) {
      case 0:
        return [n, s, o];

      case 1:
        return [c, n, o];

      case 2:
        return [o, n, s];

      case 3:
        return [o, c, n];

      case 4:
        return [s, o, n];

      case 5:
        return [n, o, c];
    }
  };

  var d = {
    amber: {
      50: "#FFF8E1",
      100: "#FFECB3",
      200: "#FFE082",
      300: "#FFB74D",
      400: "#FFCA28",
      500: "#FFC107",
      600: "#FFB300",
      700: "#FFA000",
      800: "#FF8F00",
      900: "#FF6F00"
    },
    blue: {
      50: "#E3F2FD",
      100: "#BBDEFB",
      200: "#90CAF9",
      300: "#64B5F6",
      400: "#42A5F5",
      500: "#2196F3",
      600: "#1E88E5",
      700: "#1976D2",
      800: "#1565C0",
      900: "#0D47A1"
    },
    blueGrey: {
      50: "#ECEFF1",
      100: "#CFD8DC",
      200: "#B0BEC5",
      300: "#90A4AE",
      400: "#78909C",
      500: "#607D8B",
      600: "#546E7A",
      700: "#455A64",
      800: "#37474F",
      900: "#263238"
    },
    brown: {
      50: "#EFEBE9",
      100: "#D7CCC8",
      200: "#BCAAA4",
      300: "#A1887F",
      400: "#8D6E63",
      500: "#795548",
      600: "#6D4C41",
      700: "#5D4037",
      800: "#4E342E",
      900: "#3E2723"
    },
    cyan: {
      50: "#E0F7FA",
      100: "#B2EBF2",
      200: "#80DEEA",
      300: "#4DD0E1",
      400: "#26C6DA",
      500: "#00BCD4",
      600: "#00ACC1",
      700: "#0097A7",
      800: "#00838F",
      900: "#006064"
    },
    deepOrange: {
      50: "#FBE9E7",
      100: "#FFCCBC",
      200: "#FFAB91",
      300: "#A1887F",
      400: "#FF7043",
      500: "#FF5722",
      600: "#F4511E",
      700: "#E64A19",
      800: "#D84315",
      900: "#BF360C"
    },
    deepPurple: {
      50: "#EDE7F6",
      100: "#D1C4E9",
      200: "#B39DDB",
      300: "#9575CD",
      400: "#7E57C2",
      500: "#673AB7",
      600: "#5E35B1",
      700: "#512DA8",
      800: "#4527A0",
      900: "#311B92"
    },
    green: {
      50: "#E8F5E9",
      100: "#C8E6C9",
      200: "#A5D6A7",
      300: "#81C784",
      400: "#66BB6A",
      500: "#4CAF50",
      600: "#43A047",
      700: "#388E3C",
      800: "#2E7D32",
      900: "#1B5E20"
    },
    grey: {
      50: "#FAFAFA",
      100: "#F5F5F5",
      200: "#EEEEEE",
      300: "#E0E0E0",
      400: "#BDBDBD",
      500: "#9E9E9E",
      600: "#757575",
      700: "#616161",
      800: "#424242",
      900: "#212121"
    },
    indigo: {
      50: "#E8EAF6",
      100: "#C5CAE9",
      200: "#9FA8DA",
      300: "#7986CB",
      400: "#5C6BC0",
      500: "#3F51B5",
      600: "#3949AB",
      700: "#303F9F",
      800: "#283593",
      900: "#1A237E"
    },
    lightBlue: {
      50: "#E1F5FE",
      100: "#B3E5FC",
      200: "#81D4FA",
      300: "#4FC3F7",
      400: "#29B6F6",
      500: "#03A9F4",
      600: "#039BE5",
      700: "#0288D1",
      800: "#0277BD",
      900: "#01579B"
    },
    lightGreen: {
      50: "#F1F8E9",
      100: "#DCEDC8",
      200: "#C5E1A5",
      300: "#AED581",
      400: "#9CCC65",
      500: "#8BC34A",
      600: "#7CB342",
      700: "#689F38",
      800: "#558B2F",
      900: "#33691E"
    },
    lime: {
      50: "#F9FBE7",
      100: "#F0F4C3",
      200: "#E6EE9C",
      300: "#DCE775",
      400: "#D4E157",
      500: "#CDDC39",
      600: "#C0CA33",
      700: "#AFB42B",
      800: "#9E9D24",
      900: "#827717"
    },
    orange: {
      50: "#FFF3E0",
      100: "#FFE0B2",
      200: "#FFCC80",
      300: "#FF8A65",
      400: "#FFA726",
      500: "#FF9800",
      600: "#FB8C00",
      700: "#F57C00",
      800: "#EF6C00",
      900: "#E65100"
    },
    pink: {
      50: "#FCE4EC",
      100: "#F8BBD0",
      200: "#F48FB1",
      300: "#F06292",
      400: "#EC407A",
      500: "#E91E63",
      600: "#D81B60",
      700: "#C2185B",
      800: "#AD1457",
      900: "#880E4F"
    },
    purple: {
      50: "#F3E5F5",
      100: "#E1BEE7",
      200: "#CE93D8",
      300: "#BA68C8",
      400: "#AB47BC",
      500: "#9C27B0",
      600: "#8E24AA",
      700: "#7B1FA2",
      800: "#6A1B9A",
      900: "#4A148C"
    },
    red: {
      50: "#FFEBEE",
      100: "#FFCDD2",
      200: "#EF9A9A",
      300: "#E57373",
      400: "#EF5350",
      500: "#F44336",
      600: "#E53935",
      700: "#D32F2F",
      800: "#C62828",
      900: "#B71C1C"
    },
    teal: {
      50: "#E0F2F1",
      100: "#B2DFDB",
      200: "#80CBC4",
      300: "#4DB6AC",
      400: "#26A69A",
      500: "#009688",
      600: "#00897B",
      700: "#00796B",
      800: "#00695C",
      900: "#004D40"
    },
    yellow: {
      50: "#FFFDE7",
      100: "#FFF9C4",
      200: "#FFF59D",
      300: "#FFF176",
      400: "#FFEE58",
      500: "#FFEB3B",
      600: "#FDD835",
      700: "#FBC02D",
      800: "#F9A825",
      900: "#F57F17"
    }
  };

  var g = /*#__PURE__*/function () {
    function g() {
      _classCallCheck(this, g);

      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "#000";
      if (e(this, "alpha", 1), e(this, "color", {}), "#" == t[0]) this.hex = t;else {
        var _e = /^(rgb|rgba|hsv)\(([0-9\%\,\.\s]+)\)$/.exec(t.trim());

        if (!_e) throw new Error("Unknown color format: " + t);
        {
          var _r2 = _e[2].split(",").map(function (t) {
            return parseInt(t.trim());
          });

          switch (_e[1]) {
            case "rgb":
              this.rgb = _r2;
              break;

            case "rgba":
              this.rgba = _r2;
              break;

            case "hsv":
              this.hsv = _r2;
              break;

            default:
              throw new Error("Unsupported color format: " + t);
          }
        }
      }
    }

    _createClass(g, [{
      key: "clone",
      value: function clone() {
        return new g("rgb(" + this.rgb.join(",") + ")");
      }
    }, {
      key: "brighterThan",
      value: function brighterThan(t, e) {
        var r = this.hsv,
            n = t.hsv;
        return r[2] >= n[2] + e || (r[2] = n[2] + e, r[2] > 360 && (r[2] = 360), this.hsv = r), this;
      }
    }, {
      key: "darkerThan",
      value: function darkerThan(t, e) {
        var r = this.hsv,
            n = t.hsv;
        return r[2] <= n[2] - e || (r[2] = n[2] - e, r[2] < 0 && (r[2] = 0), this.hsv = r), this;
      }
    }, {
      key: "brighterOrDarkerThan",
      value: function brighterOrDarkerThan(t, e) {
        var r = this.hsv,
            n = t.hsv;
        return r[2] <= n[2] ? this.darkerThan(t, e) : this.brighterThan(t, e);
      }
    }, {
      key: "rgbToHex",
      value: function rgbToHex(t) {
        return p(t);
      }
    }, {
      key: "hexToRgb",
      value: function hexToRgb(t) {
        return s(t).map(function (t) {
          return Math.round(t);
        });
      }
    }, {
      key: "rgbToHsv",
      value: function rgbToHsv(t) {
        return u(t).map(function (t) {
          return Math.round(t);
        });
      }
    }, {
      key: "hsvToRgb",
      value: function hsvToRgb(t) {
        return h(t).map(function (t) {
          return Math.round(t);
        });
      }
    }, {
      key: "rgb",
      set: function set(t) {
        if (3 != t.length) throw new Error("An array with a length of 3 is expected.");
        this.alpha = 1, this.color = {
          rgb: t
        };
      },
      get: function get() {
        return this.color.rgb = this.color.rgb || (this.color.hex ? this.hexToRgb(this.hex) : this.hsvToRgb(this.hsv));
      }
    }, {
      key: "rgba",
      set: function set(t) {
        if (4 != t.length) throw new Error("An array with a length of 3 is expected.");
        this.rgb = [t[0], t[1], t[2]], this.alpha = t[3];
      },
      get: function get() {
        return [this.rgb[0], this.rgb[1], this.rgb[2], this.alpha];
      }
    }, {
      key: "hsv",
      set: function set(t) {
        if (3 != t.length) throw new Error("An array with a length of 3 is expected.");
        this.alpha = 1, this.color = {
          hsv: t
        };
      },
      get: function get() {
        return (this.color.hsv = this.color.hsv || this.rgbToHsv(this.rgb)).slice(0);
      }
    }, {
      key: "hex",
      set: function set(t) {
        this.alpha = 1, this.color = {
          hex: t
        };
      },
      get: function get() {
        return (this.color.hex = this.color.hex || this.rgbToHex(this.rgb)).slice(0);
      }
    }]);

    return g;
  }();

  e(g, "collection", d);

  var m = Object.freeze({
    __proto__: null,
    collection: d,
    "default": g
  }),
      b = function b(t) {
    return null != t && "object" == typeof t && !1 === Array.isArray(t);
  };
  /*!
     * isobject <https://github.com/jonschlinkert/isobject>
     *
     * Copyright (c) 2014-2017, Jon Schlinkert.
     * Released under the MIT License.
     */

  /*!
     * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
     *
     * Copyright (c) 2014-2017, Jon Schlinkert.
     * Released under the MIT License.
     */


  function v(t) {
    return !0 === b(t) && "[object Object]" === Object.prototype.toString.call(t);
  }

  var y = {}.toString,
      F = Array.isArray || function (t) {
    return "[object Array]" == y.call(t);
  },
      A = function A(t, e) {
    if (null == t) return !1;
    if ("boolean" == typeof t) return !0;
    if ("number" == typeof t) return 0 !== t || !0 !== e;
    if (void 0 !== t.length) return 0 !== t.length;

    for (var r in t) {
      if (t.hasOwnProperty(r)) return !0;
    }

    return !1;
  };

  function E(t) {
    return t ? Array.isArray(t) ? t.join(".") : t : "";
  }
  /*!
     * has-value <https://github.com/jonschlinkert/has-value>
     *
     * Copyright (c) 2014-2016, Jon Schlinkert.
     * Licensed under the MIT License.
     */


  var C = function C(t, e, r) {
    return null != (n = t) && "object" == typeof n && !1 === F(n) ? A(function (t, e, r, n, a) {
      if (null === (i = t) || "object" != typeof i && "function" != typeof i || !e) return t;
      var i;
      if (e = E(e), r && (e += "." + E(r)), n && (e += "." + E(n)), a && (e += "." + E(a)), e in t) return t[e];

      for (var o = e.split("."), c = o.length, s = -1; t && ++s < c;) {
        for (var u = o[s]; "\\" === u[u.length - 1];) {
          u = u.slice(0, -1) + "." + o[++s];
        }

        t = t[u];
      }

      return t;
    }(t, e), r) : A(t, e);
    var n;
  },
      w = function w(t, e) {
    if (!b(t)) throw new TypeError("expected an object.");
    if (t.hasOwnProperty(e)) return delete t[e], !0;

    if (C(t, e)) {
      for (var r = e.split("."), n = r.pop(); r.length && "\\" === r[r.length - 1].slice(-1);) {
        n = r.pop().slice(0, -1) + "." + n;
      }

      for (; r.length;) {
        t = t[e = r.shift()];
      }

      return delete t[n];
    }

    return !0;
  },
      x = function t(e, r) {
    if (void 0 === e) return {};

    if (Array.isArray(e)) {
      for (var n = 0; n < e.length; n++) {
        e[n] = t(e[n], r);
      }

      return e;
    }

    if (!1 === v(a = e) || "function" != typeof (i = a.constructor) || !1 === v(o = i.prototype) || !1 === o.hasOwnProperty("isPrototypeOf")) return e;
    var a, i, o;
    if ("string" == typeof r && (r = [r]), !Array.isArray(r)) return e;

    for (var c = 0; c < r.length; c++) {
      w(e, r[c]);
    }

    for (var s in e) {
      e.hasOwnProperty(s) && (e[s] = t(e[s], r));
    }

    return e;
  },
      B = function B(t) {
    return null != t && (_(t) || function (t) {
      return "function" == typeof t.readFloatLE && "function" == typeof t.slice && _(t.slice(0, 0));
    }(t) || !!t._isBuffer);
  };
  /*!
     * unset-value <https://github.com/jonschlinkert/unset-value>
     *
     * Copyright (c) 2015, 2017, Jon Schlinkert.
     * Released under the MIT License.
     */


  function _(t) {
    return !!t.constructor && "function" == typeof t.constructor.isBuffer && t.constructor.isBuffer(t);
  }

  var D = Object.prototype.toString,
      j = function j(t) {
    if (void 0 === t) return "undefined";
    if (null === t) return "null";
    if (!0 === t || !1 === t || t instanceof Boolean) return "boolean";
    if ("string" == typeof t || t instanceof String) return "string";
    if ("number" == typeof t || t instanceof Number) return "number";
    if ("function" == typeof t || t instanceof Function) return "function";
    if (void 0 !== Array.isArray && Array.isArray(t)) return "array";
    if (t instanceof RegExp) return "regexp";
    if (t instanceof Date) return "date";
    var e = D.call(t);
    return "[object RegExp]" === e ? "regexp" : "[object Date]" === e ? "date" : "[object Arguments]" === e ? "arguments" : "[object Error]" === e ? "error" : B(t) ? "buffer" : "[object Set]" === e ? "set" : "[object WeakSet]" === e ? "weakset" : "[object Map]" === e ? "map" : "[object WeakMap]" === e ? "weakmap" : "[object Symbol]" === e ? "symbol" : "[object Int8Array]" === e ? "int8array" : "[object Uint8Array]" === e ? "uint8array" : "[object Uint8ClampedArray]" === e ? "uint8clampedarray" : "[object Int16Array]" === e ? "int16array" : "[object Uint16Array]" === e ? "uint16array" : "[object Int32Array]" === e ? "int32array" : "[object Uint32Array]" === e ? "uint32array" : "[object Float32Array]" === e ? "float32array" : "[object Float64Array]" === e ? "float64array" : "object";
  };

  function k(t) {
    var e = {
      exports: {}
    };
    return t(e, e.exports), e.exports;
  }

  var O = k(function (t) {
    !function () {
      function e(t, e) {
        if ("function" != typeof e) return t;
        var r = {};

        for (var n in t) {
          Object.prototype.hasOwnProperty.call(t, n) && (r[e(n, t[n]) || n] = t[n]);
        }

        return r;
      }

      t.exports ? t.exports = e : window.rename = e;
    }();
  }),
      N = function t(e, r) {
    var n = j(e);
    if ("object" !== n && "array" !== n) throw new Error("expected an object");
    var a = [];

    for (var i in "object" === n && (e = O(e, r), a = {}), e) {
      if (e.hasOwnProperty(i)) {
        var o = e[i];
        "object" === j(o) || "array" === j(o) ? a[i] = t(o, r) : a[i] = o;
      }
    }

    return a;
  },
      M = k(function (t) {
    var e = Object.prototype.hasOwnProperty,
        r = "~";

    function n() {}

    function a(t, e, r) {
      this.fn = t, this.context = e, this.once = r || !1;
    }

    function i() {
      this._events = new n(), this._eventsCount = 0;
    }

    Object.create && (n.prototype = Object.create(null), new n().__proto__ || (r = !1)), i.prototype.eventNames = function () {
      var t,
          n,
          a = [];
      if (0 === this._eventsCount) return a;

      for (n in t = this._events) {
        e.call(t, n) && a.push(r ? n.slice(1) : n);
      }

      return Object.getOwnPropertySymbols ? a.concat(Object.getOwnPropertySymbols(t)) : a;
    }, i.prototype.listeners = function (t, e) {
      var n = r ? r + t : t,
          a = this._events[n];
      if (e) return !!a;
      if (!a) return [];
      if (a.fn) return [a.fn];

      for (var i = 0, o = a.length, c = new Array(o); i < o; i++) {
        c[i] = a[i].fn;
      }

      return c;
    }, i.prototype.emit = function (t, e, n, a, i, o) {
      var c = r ? r + t : t;
      if (!this._events[c]) return !1;
      var s,
          u,
          l = this._events[c],
          f = arguments.length;

      if (l.fn) {
        switch (l.once && this.removeListener(t, l.fn, void 0, !0), f) {
          case 1:
            return l.fn.call(l.context), !0;

          case 2:
            return l.fn.call(l.context, e), !0;

          case 3:
            return l.fn.call(l.context, e, n), !0;

          case 4:
            return l.fn.call(l.context, e, n, a), !0;

          case 5:
            return l.fn.call(l.context, e, n, a, i), !0;

          case 6:
            return l.fn.call(l.context, e, n, a, i, o), !0;
        }

        for (u = 1, s = new Array(f - 1); u < f; u++) {
          s[u - 1] = arguments[u];
        }

        l.fn.apply(l.context, s);
      } else {
        var p,
            h = l.length;

        for (u = 0; u < h; u++) {
          switch (l[u].once && this.removeListener(t, l[u].fn, void 0, !0), f) {
            case 1:
              l[u].fn.call(l[u].context);
              break;

            case 2:
              l[u].fn.call(l[u].context, e);
              break;

            case 3:
              l[u].fn.call(l[u].context, e, n);
              break;

            case 4:
              l[u].fn.call(l[u].context, e, n, a);
              break;

            default:
              if (!s) for (p = 1, s = new Array(f - 1); p < f; p++) {
                s[p - 1] = arguments[p];
              }
              l[u].fn.apply(l[u].context, s);
          }
        }
      }

      return !0;
    }, i.prototype.on = function (t, e, n) {
      var i = new a(e, n || this),
          o = r ? r + t : t;
      return this._events[o] ? this._events[o].fn ? this._events[o] = [this._events[o], i] : this._events[o].push(i) : (this._events[o] = i, this._eventsCount++), this;
    }, i.prototype.once = function (t, e, n) {
      var i = new a(e, n || this, !0),
          o = r ? r + t : t;
      return this._events[o] ? this._events[o].fn ? this._events[o] = [this._events[o], i] : this._events[o].push(i) : (this._events[o] = i, this._eventsCount++), this;
    }, i.prototype.removeListener = function (t, e, a, i) {
      var o = r ? r + t : t;
      if (!this._events[o]) return this;
      if (!e) return 0 == --this._eventsCount ? this._events = new n() : delete this._events[o], this;
      var c = this._events[o];
      if (c.fn) c.fn !== e || i && !c.once || a && c.context !== a || (0 == --this._eventsCount ? this._events = new n() : delete this._events[o]);else {
        for (var s = 0, u = [], l = c.length; s < l; s++) {
          (c[s].fn !== e || i && !c[s].once || a && c[s].context !== a) && u.push(c[s]);
        }

        u.length ? this._events[o] = 1 === u.length ? u[0] : u : 0 == --this._eventsCount ? this._events = new n() : delete this._events[o];
      }
      return this;
    }, i.prototype.removeAllListeners = function (t) {
      var e;
      return t ? (e = r ? r + t : t, this._events[e] && (0 == --this._eventsCount ? this._events = new n() : delete this._events[e])) : (this._events = new n(), this._eventsCount = 0), this;
    }, i.prototype.off = i.prototype.removeListener, i.prototype.addListener = i.prototype.on, i.prototype.setMaxListeners = function () {
      return this;
    }, i.prefixed = r, i.EventEmitter = i, t.exports = i;
  });
  /*!
     * deep-rename-keys <https://github.com/jonschlinkert/deep-rename-keys>
     *
     * Copyright (c) 2015 Jon Schlinkert, contributors.
     * Licensed under the MIT license.
     */


  function S(t, e, r) {
    return e in t ? Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = r, t;
  }

  var T = function T() {},
      z = {
    data: "state-data",
    cdata: "state-cdata",
    tagBegin: "state-tag-begin",
    tagName: "state-tag-name",
    tagEnd: "state-tag-end",
    attributeNameStart: "state-attribute-name-start",
    attributeName: "state-attribute-name",
    attributeNameEnd: "state-attribute-name-end",
    attributeValueBegin: "state-attribute-value-begin",
    attributeValue: "state-attribute-value"
  },
      R = {
    lt: "action-lt",
    gt: "action-gt",
    space: "action-space",
    equal: "action-equal",
    quote: "action-quote",
    slash: "action-slash",
    "char": "action-char",
    error: "action-error"
  },
      q = {
    text: "text",
    openTag: "open-tag",
    closeTag: "close-tag",
    attributeName: "attribute-name",
    attributeValue: "attribute-value"
  },
      P = {
    " ": R.space,
    "\t": R.space,
    "\n": R.space,
    "\r": R.space,
    "<": R.lt,
    ">": R.gt,
    '"': R.quote,
    "'": R.quote,
    "=": R.equal,
    "/": R.slash
  },
      V = function V(t) {
    var e, r, n, a, i, o, c, s, u, l;
    t = Object.assign({
      debug: !1
    }, t);

    var f = new M(),
        p = z.data,
        h = "",
        d = "",
        g = "",
        m = "",
        b = "",
        v = "",
        y = function y(e, r) {
      if ("?" !== d[0] && "!" !== d[0]) {
        var n = {
          type: e,
          value: r
        };
        t.debug && console.log("emit:", n), f.emit("data", n);
      }
    };

    f.stateMachine = (S(l = {}, z.data, (S(e = {}, R.lt, function () {
      h.trim() && y(q.text, h), d = "", b = !1, p = z.tagBegin;
    }), S(e, R["char"], function (t) {
      h += t;
    }), e)), S(l, z.cdata, S({}, R["char"], function (t) {
      "]]>" === (h += t).substr(-3) && (y(q.text, h.slice(0, -3)), h = "", p = z.data);
    })), S(l, z.tagBegin, (S(r = {}, R.space, T), S(r, R["char"], function (t) {
      d = t, p = z.tagName;
    }), S(r, R.slash, function () {
      d = "", b = !0;
    }), r)), S(l, z.tagName, (S(n = {}, R.space, function () {
      b ? p = z.tagEnd : (p = z.attributeNameStart, y(q.openTag, d));
    }), S(n, R.gt, function () {
      y(b ? q.closeTag : q.openTag, d), h = "", p = z.data;
    }), S(n, R.slash, function () {
      p = z.tagEnd, y(q.openTag, d);
    }), S(n, R["char"], function (t) {
      "![CDATA[" === (d += t) && (p = z.cdata, h = "", d = "");
    }), n)), S(l, z.tagEnd, (S(a = {}, R.gt, function () {
      y(q.closeTag, d), h = "", p = z.data;
    }), S(a, R["char"], T), a)), S(l, z.attributeNameStart, (S(i = {}, R["char"], function (t) {
      g = t, p = z.attributeName;
    }), S(i, R.gt, function () {
      h = "", p = z.data;
    }), S(i, R.space, T), S(i, R.slash, function () {
      b = !0, p = z.tagEnd;
    }), i)), S(l, z.attributeName, (S(o = {}, R.space, function () {
      p = z.attributeNameEnd;
    }), S(o, R.equal, function () {
      y(q.attributeName, g), p = z.attributeValueBegin;
    }), S(o, R.gt, function () {
      m = "", y(q.attributeName, g), y(q.attributeValue, m), h = "", p = z.data;
    }), S(o, R.slash, function () {
      b = !0, m = "", y(q.attributeName, g), y(q.attributeValue, m), p = z.tagEnd;
    }), S(o, R["char"], function (t) {
      g += t;
    }), o)), S(l, z.attributeNameEnd, (S(c = {}, R.space, T), S(c, R.equal, function () {
      y(q.attributeName, g), p = z.attributeValueBegin;
    }), S(c, R.gt, function () {
      m = "", y(q.attributeName, g), y(q.attributeValue, m), h = "", p = z.data;
    }), S(c, R["char"], function (t) {
      m = "", y(q.attributeName, g), y(q.attributeValue, m), g = t, p = z.attributeName;
    }), c)), S(l, z.attributeValueBegin, (S(s = {}, R.space, T), S(s, R.quote, function (t) {
      v = t, m = "", p = z.attributeValue;
    }), S(s, R.gt, function () {
      y(q.attributeValue, m = ""), h = "", p = z.data;
    }), S(s, R["char"], function (t) {
      v = "", m = t, p = z.attributeValue;
    }), s)), S(l, z.attributeValue, (S(u = {}, R.space, function (t) {
      v ? m += t : (y(q.attributeValue, m), p = z.attributeNameStart);
    }), S(u, R.quote, function (t) {
      v === t ? (y(q.attributeValue, m), p = z.attributeNameStart) : m += t;
    }), S(u, R.gt, function (t) {
      v ? m += t : (y(q.attributeValue, m), h = "", p = z.data);
    }), S(u, R.slash, function (t) {
      v ? m += t : (y(q.attributeValue, m), b = !0, p = z.tagEnd);
    }), S(u, R["char"], function (t) {
      m += t;
    }), u)), l);

    var F = function F(e) {
      t.debug && console.log(p, e);

      var r = f.stateMachine[p],
          n = r[function (t) {
        return P[t] || R["char"];
      }(e)] || r[R.error] || r[R["char"]];

      n(e);
    };

    return f.write = function (t) {
      for (var e = t.length, r = 0; r < e; r++) {
        F(t[r]);
      }
    }, f;
  },
      W = q,
      I = {
    element: "element",
    text: "text"
  },
      U = function U(t) {
    return Object.assign({
      name: "",
      type: I.element,
      value: "",
      parent: null,
      attributes: {},
      children: []
    }, t);
  },
      L = function L(t) {
    t = Object.assign({
      stream: !1,
      parentNodes: !0,
      doneEvent: "done",
      tagPrefix: "tag:",
      emitTopLevelOnly: !1,
      debug: !1
    }, t);

    var e = void 0,
        r = void 0,
        n = void 0,
        a = void 0,
        i = new M(),
        o = function o(_o) {
      switch (_o.type) {
        case W.openTag:
          if (null === n) (n = r).name = _o.value;else {
            var c = U({
              name: _o.value,
              parent: n
            });
            n.children.push(c), n = c;
          }
          break;

        case W.closeTag:
          var s = n.parent;
          if (t.parentNodes || (n.parent = null), n.name !== _o.value) break;
          t.stream && s === r && (r.children = [], n.parent = null), t.emitTopLevelOnly && s !== r || (i.emit(t.tagPrefix + n.name, n), i.emit("tag", n.name, n)), n === r && (e.removeAllListeners("data"), i.emit(t.doneEvent, n), r = null), n = s;
          break;

        case W.text:
          n && n.children.push(U({
            type: I.text,
            value: _o.value,
            parent: t.parentNodes ? n : null
          }));
          break;

        case W.attributeName:
          a = _o.value, n.attributes[a] = "";
          break;

        case W.attributeValue:
          n.attributes[a] = _o.value;
      }
    };

    return i.reset = function () {
      (e = V({
        debug: t.debug
      })).on("data", o), r = U(), n = null, a = "", i.parse = e.write;
    }, i.reset(), i;
  },
      $ = function $(t, e) {
    e = Object.assign({}, e, {
      stream: !1,
      tagPrefix: ":"
    });
    var r = L(e),
        n = void 0;
    return r.on("done", function (t) {
      n = t;
    }), r.parse(t), n;
  },
      H = function H(t) {
    var e = $("<root>".concat(t, "</root>"), {
      parentNodes: !1
    });
    if (e.children && e.children.length > 0 && e.children.every(function (t) {
      return "svg" === t.name;
    })) return 1 === e.children.length ? e.children[0] : e.children;
    throw Error("nothing to parse");
  },
      Z = function Z(t) {
    return x(t, ["parent"]);
  },
      X = function X(t) {
    return N(t, function (t) {
      return G(t) ? t : Y(t);
    });
  },
      Y = function Y(t) {
    return t.replace(/[-|:]([a-z])/gi, function (t, e) {
      return e.toUpperCase();
    });
  },
      G = function G(t) {
    return /^(data|aria)(-\w+)/.test(t);
  },
      J = function J(t) {
    if (t) {
      var e = String(t);
      return /[&<>]/.test(e) ? "<![CDATA[".concat(e.replace(/]]>/, "]]]]><![CDATA[>"), "]]>") : e;
    }

    return "";
  },
      K = function K(t) {
    return String(t).replace(/&/g, "&amp;").replace(/'/g, "&apos;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  },
      Q = function t(e) {
    var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        n = r.transformAttr,
        a = void 0 === n ? function (t, e, r) {
      return "".concat(t, '="').concat(r(e), '"');
    } : n,
        i = r.transformNode,
        o = void 0 === i ? function (t) {
      return t;
    } : i,
        c = r.selfClose,
        s = void 0 === c || c;
    if (Array.isArray(e)) return e.map(function (e) {
      return t(e, {
        transformAttr: a,
        selfClose: s,
        transformNode: o
      });
    }).join("");
    var u = o(e);
    if ("text" === u.type) return J(u.value);
    var l = "";

    for (var f in u.attributes) {
      var p = a(f, u.attributes[f], K, u.name);
      l += p ? " ".concat(p) : "";
    }

    return u.children && u.children.length > 0 || !s ? "<".concat(u.name).concat(l, ">").concat(t(u.children, {
      transformAttr: a,
      transformNode: o,
      selfClose: s
    }), "</").concat(u.name, ">") : "<".concat(u.name).concat(l, "/>");
  };

  var tt = /*#__PURE__*/function () {
    function tt() {
      _classCallCheck(this, tt);
    }

    _createClass(tt, null, [{
      key: "parse",
      value: function parse(t) {
        return "string" == typeof t ? function (t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = e.transformNode,
              n = void 0 === r ? function (t) {
            return t;
          } : r,
              a = e.camelcase,
              i = void 0 !== a && a,
              o = function o(t) {
            var e;
            return e = Z(t), e = n(e), i && (e = X(e)), e;
          };

          return o(H(t));
        }(t) : t;
      }
    }, {
      key: "stringify",
      value: function stringify(t) {
        return "string" == typeof t ? t : Q(t);
      }
    }]);

    return tt;
  }();

  function et(t) {
    return t.replace(/&/g, "&amp;").replace(/'/g, "&apos;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }

  var rt = Object.freeze({
    __proto__: null,
    xml: et
  });
  var nt = {
    type: "object",
    $schema: "http://json-schema.org/draft-07/schema#",
    title: "Options",
    properties: {
      seed: {
        title: "Seed",
        type: "string"
      },
      s: {
        title: "Seed",
        type: "string"
      },
      base64: {
        title: "Base64",
        description: "@deprecated use dataUri instead",
        type: "boolean",
        "default": !1
      },
      dataUri: {
        title: "Data URI",
        type: "boolean",
        "default": !1
      },
      userAgent: {
        title: "User Agent",
        description: "@deprecated",
        type: "string"
      },
      flip: {
        title: "Flip",
        type: "boolean",
        "default": !1
      },
      rotate: {
        title: "Rotate",
        type: "integer",
        minimum: 0,
        maximum: 360,
        "default": 0
      },
      scale: {
        title: "Scale",
        type: "integer",
        minimum: 0,
        maximum: 200,
        "default": 100
      },
      radius: {
        title: "Radius",
        type: "integer",
        minimum: 0,
        maximum: 50,
        "default": 0
      },
      r: {
        title: "Radius",
        type: "integer",
        minimum: 0,
        maximum: 50,
        "default": 0
      },
      width: {
        title: "Width",
        description: "@deprecated use size instead",
        type: "integer",
        minimum: 1
      },
      w: {
        title: "Width",
        description: "@deprecated use size instead",
        type: "integer",
        minimum: 1
      },
      height: {
        title: "Height",
        description: "@deprecated use size instead",
        type: "integer",
        minimum: 1
      },
      h: {
        title: "Height",
        description: "@deprecated use size instead",
        type: "integer",
        minimum: 1
      },
      size: {
        title: "Size",
        type: "integer",
        minimum: 1
      },
      margin: {
        title: "Margin",
        description: "@deprecated use scale instead",
        type: "integer",
        minimum: 0,
        maximum: 25,
        "default": 0
      },
      m: {
        title: "Margin",
        description: "@deprecated use scale instead",
        type: "integer",
        minimum: 0,
        maximum: 25,
        "default": 0
      },
      backgroundColor: {
        title: "Background Color",
        anyOf: [{
          type: "string",
          pattern: "^#([a-fA-F0-9]{3}|[a-fA-F0-9]{4}|[a-fA-F0-9]{6}|[a-fA-F0-9]{8})$"
        }, {
          type: "string",
          pattern: "^[0-9a-zA-Z]+$"
        }, {
          type: "array",
          items: {
            anyOf: [{
              type: "string",
              pattern: "^#([a-fA-F0-9]{3}|[a-fA-F0-9]{4}|[a-fA-F0-9]{6}|[a-fA-F0-9]{8})$"
            }, {
              type: "string",
              pattern: "^[0-9a-zA-Z]+$"
            }]
          }
        }]
      },
      background: {
        title: "Background Color",
        anyOf: [{
          type: "string",
          pattern: "^#([a-fA-F0-9]{3}|[a-fA-F0-9]{4}|[a-fA-F0-9]{6}|[a-fA-F0-9]{8})$"
        }, {
          type: "string",
          pattern: "^[0-9a-zA-Z]+$"
        }, {
          type: "array",
          items: {
            anyOf: [{
              type: "string",
              pattern: "^#([a-fA-F0-9]{3}|[a-fA-F0-9]{4}|[a-fA-F0-9]{6}|[a-fA-F0-9]{8})$"
            }, {
              type: "string",
              pattern: "^[0-9a-zA-Z]+$"
            }]
          }
        }],
        description: "@deprecated use backgroundColor instead"
      },
      b: {
        title: "Background Color",
        anyOf: [{
          type: "string",
          pattern: "^#([a-fA-F0-9]{3}|[a-fA-F0-9]{4}|[a-fA-F0-9]{6}|[a-fA-F0-9]{8})$"
        }, {
          type: "string",
          pattern: "^[0-9a-zA-Z]+$"
        }, {
          type: "array",
          items: {
            anyOf: [{
              type: "string",
              pattern: "^#([a-fA-F0-9]{3}|[a-fA-F0-9]{4}|[a-fA-F0-9]{6}|[a-fA-F0-9]{8})$"
            }, {
              type: "string",
              pattern: "^[0-9a-zA-Z]+$"
            }]
          }
        }]
      },
      translateX: {
        title: "Translate X%",
        type: "integer",
        minimum: -100,
        maximum: 100,
        "default": 0
      },
      translateY: {
        title: "Translate Y%",
        type: "integer",
        minimum: -100,
        maximum: 100,
        "default": 0
      }
    },
    additionalProperties: !1
  };

  function at(t) {
    return t.properties || {};
  }

  function it(t) {
    var e = {},
        r = at(t);
    return Object.keys(r).forEach(function (t) {
      var n = r[t];
      "object" == typeof n && void 0 !== n["default"] && (Array.isArray(n["default"]) ? e[t] = _toConsumableArray(n["default"]) : "object" == typeof n["default"] ? e[t] = _objectSpread({}, n["default"]) : e[t] = n["default"]);
    }), e;
  }

  function ot(t) {
    var e = {},
        r = at(t);
    return Object.keys(r).forEach(function (t) {
      var n = r[t];

      if ("object" == typeof n) {
        var _r3 = n.title;
        _r3 && (e[_r3] = e[_r3] || [], e[_r3].push(t));
      }
    }), Object.values(e).filter(function (t) {
      return t.length > 1;
    }).map(function (t) {
      return t.sort().sort(function (t, e) {
        return t.length === e.length ? 0 : t.length > e.length ? 1 : -1;
      });
    });
  }

  function ct(t) {
    var e = new Map();

    var _iterator = _createForOfIteratorHelper(ot(t)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _r4 = _step.value;

        var _r4$reverse = _r4.reverse(),
            _r4$reverse2 = _toArray(_r4$reverse),
            _t2 = _r4$reverse2[0],
            _n = _r4$reverse2.slice(1);

        var _iterator2 = _createForOfIteratorHelper(_n),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _r5 = _step2.value;
            e.set(_r5, _t2);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return e;
  }

  var st = Object.freeze({
    __proto__: null,
    properties: at,
    defaults: it,
    aliases: ot,
    aliasesMap: ct
  });

  function ut(t, e) {
    var r = t[e],
        n = _objectWithoutProperties(t, [e].map(_toPropertyKey));

    return n;
  }

  var lt = Object.freeze({
    __proto__: null,
    omit: ut
  });

  function ft(t, e) {
    var r = [{
      seed: Math.random().toString(),
      userAgent: "undefined" != typeof window && window.navigator && window.navigator.userAgent
    }, it(nt), it(t.schema), e],
        n = pt(t);
    return r.forEach(function (t) {
      n = Object.assign(n, ut(t, "_aliases"));
    }), n;
  }

  function pt(t) {
    var e = new Map([].concat(_toConsumableArray(Array.from(ct(nt))), _toConsumableArray(Array.from(ct(t.schema)))));
    return new Proxy({
      _aliases: e
    }, {
      get: function get(t, e) {
        var r;
        var n = null !== (r = t._aliases.get(e)) && void 0 !== r ? r : e;
        return t[n];
      },
      set: function set(t, e, r) {
        var n;
        var a = null !== (n = t._aliases.get(e)) && void 0 !== n ? n : e;
        return t[a] = r, !0;
      },
      deleteProperty: function deleteProperty(t, e) {
        var r;
        var n = null !== (r = t._aliases.get(e)) && void 0 !== r ? r : e;
        return delete t[n], !0;
      }
    });
  }

  var ht = Object.freeze({
    __proto__: null,
    merge: ft,
    createAliasProxy: pt
  });
  var dt = {
    by: {
      permits: ["Reproduction", "Distribution", "DerivativeWorks"],
      requires: ["Notice", "Attribution"],
      prohibits: []
    },
    "by-sa": {
      permits: ["Reproduction", "Distribution", "DerivativeWorks"],
      requires: ["Notice", "Attribution", "ShareAlike"],
      prohibits: []
    },
    "by-nd": {
      permits: ["Reproduction", "Distribution"],
      requires: ["Notice", "Attribution"],
      prohibits: []
    },
    "by-nc": {
      permits: ["Reproduction", "Distribution", "DerivativeWorks"],
      requires: ["Notice", "Attribution"],
      prohibits: ["CommercialUse"]
    },
    "by-nc-sa": {
      permits: ["Reproduction", "Distribution", "DerivativeWorks"],
      requires: ["Notice", "Attribution", "ShareAlike"],
      prohibits: ["CommercialUse"]
    },
    "by-nc-nd": {
      permits: ["Reproduction", "Distribution"],
      requires: ["Notice", "Attribution"],
      prohibits: ["CommercialUse"]
    },
    zero: {
      permits: ["Reproduction", "Distribution", "DerivativeWorks"],
      requires: [],
      prohibits: []
    }
  };

  function gt() {
    return {
      "xmlns:dc": "http://purl.org/dc/elements/1.1/",
      "xmlns:cc": "http://creativecommons.org/ns#",
      "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
      "xmlns:svg": "http://www.w3.org/2000/svg",
      xmlns: "http://www.w3.org/2000/svg"
    };
  }

  function mt(t) {
    return '\n<metadata>\n<rdf:RDF>\n<cc:Work>\n<dc:format>image/svg+xml</dc:format>\n<dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />\n'.concat(bt(t), "\n").concat(vt(t), "\n").concat(yt(t), "\n").concat(Ft(t), "\n").concat(At(t), "\n</cc:Work>\n").concat(Ct(t), "\n</rdf:RDF>\n</metadata>\n");
  }

  function bt(t) {
    return t.meta.title ? "<dc:title>".concat(t.meta.title, "</dc:title>") : "";
  }

  function vt(t) {
    if (t.meta.creator) {
      var _e2 = Array.isArray(t.meta.creator) ? t.meta.creator : [t.meta.creator];

      return "\n<dc:creator>\n".concat(Et(_e2), "\n</dc:creator>\n");
    }

    return "";
  }

  function yt(t) {
    return t.meta.source ? "<dc:source>".concat(t.meta.source, "</dc:source>") : "";
  }

  function Ft(t) {
    return t.meta.license ? '<cc:license rdf:resource="'.concat(t.meta.license.url, '" />') : "";
  }

  function At(t) {
    if (t.meta.contributor) {
      var _e3 = Array.isArray(t.meta.contributor) ? t.meta.contributor : [t.meta.contributor];

      return "\n<dc:contributor>\n".concat(Et(_e3), "\n</dc:contributor>\n");
    }

    return "";
  }

  function Et(t) {
    return t.map(function (t) {
      return "\n<cc:Agent>\n<dc:title>".concat(t, "</dc:title>\n</cc:Agent>\n");
    });
  }

  function Ct(t) {
    var e;
    var r = null === (e = t.meta.license) || void 0 === e ? void 0 : e.url.match(/^https?:\/\/creativecommons.org\/(?:licenses|publicdomain)\/([a-z\-]+)\/\d.\d\//);

    if (r) {
      var _e4 = dt[r[1]];

      if (_e4) {
        var n;
        var _r6 = "";
        return _e4.permits.forEach(function (t) {
          _r6 += '<cc:permits rdf:resource="https://creativecommons.org/ns#'.concat(t, '" />');
        }), _e4.requires.forEach(function (t) {
          _r6 += '<cc:requires rdf:resource="https://creativecommons.org/ns#'.concat(t, '" />');
        }), _e4.prohibits.forEach(function (t) {
          _r6 += '<cc:prohibits rdf:resource="https://creativecommons.org/ns#'.concat(t, '" />');
        }), '\n<cc:License rdf:about="'.concat(null === (n = t.meta.license) || void 0 === n ? void 0 : n.url, '">\n').concat(_r6, "\n</cc:License>\n");
      }
    }

    return "";
  }

  function wt(t) {
    var e = t.attributes.viewBox.split(" ");
    return {
      x: parseInt(e[0]),
      y: parseInt(e[1]),
      width: parseInt(e[2]),
      height: parseInt(e[3])
    };
  }

  function xt(t, e) {
    var r;
    return _t(t, 100 - 2 * ("number" == typeof e ? e : null !== (r = e.margin) && void 0 !== r ? r : 0));
  }

  function Bt(t, e) {
    var r;

    var _wt = wt(t),
        n = _wt.width,
        a = _wt.height,
        i = _wt.x,
        o = _wt.y,
        c = "string" == typeof e ? e : null !== (r = e.backgroundColor) && void 0 !== r ? r : "transparent";

    return '\n<rect fill="'.concat(c, '" width="').concat(n, '" height="').concat(a, '" x="').concat(i, '" y="').concat(o, '" />\n').concat(t.body, "\n");
  }

  function _t(t, e) {
    var _wt2 = wt(t),
        r = _wt2.width,
        n = _wt2.height,
        a = _wt2.x,
        i = _wt2.y,
        o = e ? (e - 100) / 100 : 0,
        c = (n / 2 + i) * o * -1;

    return '\n<g transform="translate('.concat((r / 2 + a) * o * -1, " ").concat(c, ") scale(").concat(e / 100, ')">\n').concat(t.body, "\n</g>\n");
  }

  function Dt(t, e, r) {
    var n = wt(t),
        a = (n.width + 2 * n.x) * ((null != e ? e : 0) / 100),
        i = (n.height + 2 * n.y) * ((null != r ? r : 0) / 100);
    return '\n<g transform="translate('.concat(a, " ").concat(i, ')">\n').concat(t.body, "\n</g>\n");
  }

  function jt(t, e) {
    var _wt3 = wt(t),
        r = _wt3.width,
        n = _wt3.height,
        a = _wt3.x,
        i = _wt3.y;

    return '\n<g transform="rotate('.concat(e, ", ").concat(r / 2 + a, ", ").concat(n / 2 + i, ')">\n').concat(t.body, "\n</g>\n");
  }

  function kt(t) {
    var _wt4 = wt(t),
        e = _wt4.width,
        r = _wt4.x;

    return '\n<g transform="scale(-1 1) translate('.concat(-1 * e - 2 * r, ' 0)">\n').concat(t.body, "\n</g>\n");
  }

  function Ot(t, e) {
    var _wt5 = wt(t),
        r = _wt5.width,
        n = _wt5.height,
        a = _wt5.x,
        i = _wt5.y,
        o = e ? r * e / 100 : 0,
        c = e ? n * e / 100 : 0;

    return '\n<mask id="avatarsRadiusMask">\n<rect width="'.concat(r, '" height="').concat(n, '" rx="').concat(o, '" ry="').concat(c, '" x="').concat(a, '" y="').concat(i, '" fill="#fff" />\n</mask>\n<g mask="url(#avatarsRadiusMask)">').concat(t.body, "</g>\n");
  }

  function Nt(t) {
    return t = _objectSpread({
      "xmlns:dc": "http://purl.org/dc/elements/1.1/",
      "xmlns:cc": "http://creativecommons.org/ns#",
      "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
      "xmlns:svg": "http://www.w3.org/2000/svg",
      xmlns: "http://www.w3.org/2000/svg"
    }, t), Object.keys(t).map(function (e) {
      return "".concat(et(e), '="').concat(et(t[e]), '"');
    }).join(" ");
  }

  function Mt(t) {
    return t.trim().replace(/\n/g, " ").replace(/>\s+</g, "><").replace(/\s{2,}/g, " ").replace(/<([^\/>]+)><\/[^>]+>/gi, "<$1/>").replace(/\s(\/?>)/g, "$1");
  }

  var St = Object.freeze({
    __proto__: null,
    createGroup: function createGroup(t) {
      var e = t.children,
          r = t.x,
          n = t.y;
      return '<g transform="translate('.concat(r, ", ").concat(n, ')">').concat(e, "</g>");
    },
    getXmlnsAttributes: gt,
    getMetadata: mt,
    getMetadataWorkTitle: bt,
    getMetadataWorkCreator: vt,
    getMetadataWorkSource: yt,
    getMetadataWorkLicense: Ft,
    getMetadataWorkContributor: At,
    getMetadataWorkAgents: Et,
    getMetadataLicense: Ct,
    getViewBox: wt,
    addMargin: xt,
    addRadius: function addRadius(t, e) {
      return void 0 === e.radius ? t.body : Ot(t, e.radius);
    },
    addBackgroundColor: Bt,
    addScale: _t,
    addTranslate: Dt,
    addRotate: jt,
    addFlip: kt,
    addViewboxMask: Ot,
    createAttrString: Nt,
    removeWhitespace: Mt
  });
  var Tt = Object.freeze({
    __proto__: null,
    createLegacyWrapper: function createLegacyWrapper(t) {
      return function (e, r) {
        var n;
        r = Object.assign(r, ft(t, r));
        var a = t.create({
          prng: i(e.seed),
          options: r
        });
        return "\n<svg ".concat(Nt(a.attributes), ">\n").concat(mt(t), "\n").concat(null !== (n = a.head) && void 0 !== n ? n : "", "\n").concat(a.body, "\n</svg>\n");
      };
    }
  }),
      zt = Object.freeze({
    __proto__: null,
    escape: rt,
    options: ht,
    prng: o,
    svg: St,
    style: Tt,
    schema: st,
    helper: lt
  });

  function Rt(t) {
    var e, r, n;
    var a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    a = ft(t, a);
    var o = i(a.seed),
        c = t.create({
      prng: o,
      options: a
    });

    if (a.size ? (c.attributes.width = a.size.toString(), c.attributes.height = a.size.toString()) : (a.width && (c.attributes.width = a.width.toString()), a.height && (c.attributes.height = a.height.toString())), void 0 !== a.scale && 100 !== a.scale ? c.body = _t(c, a.scale) : a.margin && (c.body = xt(c, a)), a.flip && (c.body = kt(c)), a.rotate && (c.body = jt(c, a.rotate)), (a.translateX || a.translateY) && (c.body = Dt(c, a.translateX, a.translateY)), a.backgroundColor) {
      var _t3 = Array.isArray(a.backgroundColor) ? o.pick(a.backgroundColor) : a.backgroundColor;

      c.body = Bt(c, _t3);
    }

    c.body = Ot(c, null !== (e = a.radius) && void 0 !== e ? e : 0);
    var s = Boolean(null === (r = c.head) || void 0 === r ? void 0 : r.match(/<metadata([^>]*)>/));
    var u = Mt("\n<svg ".concat(Nt(c.attributes), ">\n").concat(s ? "" : mt(t), "\n").concat(null !== (n = c.head) && void 0 !== n ? n : "", "\n").concat(c.body, "\n</svg>\n"));
    if (a.dataUri) return "data:image/svg+xml;utf8,".concat(encodeURIComponent(u));

    if (a.base64) {
      var _t4 = encodeURIComponent(u).replace(/%([0-9A-F]{2})/g, function (t, e) {
        return String.fromCharCode(parseInt("0x".concat(e)));
      });

      return "data:image/svg+xml;base64,".concat(btoa(_t4));
    }

    return u;
  }

  var qt = /*#__PURE__*/function () {
    function qt(t, r) {
      _classCallCheck(this, qt);

      e(this, "spriteCollection", void 0), e(this, "defaultOptions", void 0), this.spriteCollection = t, this.defaultOptions = r;
    }

    _createClass(qt, [{
      key: "create",
      value: function create(t, e) {
        var _this = this;

        var r = {
          meta: {},
          schema: {},
          create: function create(t) {
            var e = t.prng,
                r = t.options,
                n = tt.parse(_this.spriteCollection(new c(e.seed), r)),
                a = [],
                i = [];
            return n.children.forEach(function (t) {
              _this.isBody(t) ? i.push(t) : a.push(t);
            }), {
              attributes: n.attributes,
              head: a.map(function (t) {
                return tt.stringify(t);
              }).join(""),
              body: i.map(function (t) {
                return tt.stringify(t);
              }).join("")
            };
          }
        };
        return Rt(r, _objectSpread(_objectSpread(_objectSpread({}, this.defaultOptions), e), {}, {
          seed: t
        }));
      }
    }, {
      key: "isBody",
      value: function isBody(t) {
        return "element" === t.type && -1 === ["title", "desc", "defs", "metadata"].indexOf(t.name);
      }
    }]);

    return qt;
  }();

  e(qt, "random", c), e(qt, "color", g), e(qt, "parser", tt), t.color = m, t.createAvatar = Rt, t["default"] = qt, t.schema = nt, t.utils = zt, Object.defineProperty(t, "__esModule", {
    value: !0
  });
});